import React from 'react';
import { Link } from 'react-router-dom';
import { PlayIcon } from 'lucide-react';
import type { Slot } from '../../types/slot';
import { useSiteSettings } from '../../contexts/SiteSettingsContext';
import { formatRtp } from '../../utils/slots';
import { SlotThumb } from '../SlotThumb';
import { ScoreBadge } from '../ScoreBadge';
import { RealMoneyButton } from '../RealMoneyButton';
export function SlotCard({
  slot,
  onDemo
}: {
  slot: Slot;
  onDemo: (s: Slot) => void;
}) {
  const {
    showRealMoneyCtas
  } = useSiteSettings();
  return <li className="flex flex-col rounded-2xl border border-line bg-surface p-5" data-id="element-213" data-mp="3uwzf9fw9385c">
      <div className="flex items-start justify-between gap-3" data-id="element-214" data-mp="3pella35prer">
        <div className="flex items-center gap-3" data-id="element-215" data-mp="8gmxccrylov3">
          <span className={`font-serif text-2xl font-semibold tabular-nums ${slot.rank <= 3 ? 'text-oranje' : 'text-muted'}`} data-id="element-216" data-mp="8ig2toqu631i">
            {slot.rank}
          </span>
          <SlotThumb slot={slot} size="md" data-id="element-217" data-mp="3c56ntpwtxuzq" />
        </div>
        <ScoreBadge score={slot.score} data-id="element-218" data-mp="3c3n9i4uqhu0l" />
      </div>
      <Link to={`/slots/${slot.slug}`} className="mt-4 font-serif text-lg font-semibold hover:underline" data-id="element-219" data-mp="gh2l4tzgvm9">
        {slot.name}
      </Link>
      <p className="text-sm text-muted" data-id="element-220" data-mp="3rpwf8jesfuea">{slot.provider}</p>
      <dl className="mt-4 grid grid-cols-3 gap-2 border-t border-line pt-4 text-sm" data-id="element-221" data-mp="3mw1sf73vyzaz">
        <div data-id="element-222" data-mp="3hys1to4rghlk">
          <dt className="text-xs text-muted" data-id="element-223" data-mp="3hx8mbzqxiaku">RTP</dt>
          <dd className="font-medium tabular-nums" data-id="element-224" data-mp="3dwezzat4x3u2">{formatRtp(slot.rtp)}</dd>
        </div>
        <div data-id="element-225" data-mp="3du29g99b9l5e">
          <dt className="text-xs text-muted" data-id="element-226" data-mp="38xlkjcuaf2r9">Volatiliteit</dt>
          <dd className="font-medium" data-id="element-227" data-mp="38w0pzn7z3jte">{slot.volatility}</dd>
        </div>
        <div data-id="element-228" data-mp="33zacn7njz2bo">
          <dt className="text-xs text-muted" data-id="element-229" data-mp="33yr1c9serc6m">Max. winst</dt>
          <dd className="font-medium tabular-nums" data-id="element-230" data-mp="2yznucjsvavw0">{slot.maxWin}</dd>
        </div>
      </dl>
      <div className="mt-auto flex gap-2 pt-5" data-id="element-231" data-mp="126m6oqjiy0s7">
        <button type="button" onClick={() => onDemo(slot)} className="inline-flex h-9 flex-1 items-center justify-center gap-1.5 rounded-lg border border-line px-3 text-sm font-semibold hover:border-ink/30" aria-label={`Speel ${slot.name} gratis demo`} data-id="element-232" data-mp="126cecwb0bhjc">
          <PlayIcon className="h-3.5 w-3.5 fill-current" aria-hidden="true" data-id="element-233" data-mp="2wg11p9zeevki" />
          Demo
        </button>
        {showRealMoneyCtas ? <RealMoneyButton slot={slot} size="sm" className="flex-1" data-id="element-234" data-mp="2mon4j8ux67uj" /> : <Link to={`/slots/${slot.slug}`} className="inline-flex h-9 flex-1 items-center justify-center rounded-lg bg-fern px-3 text-sm font-semibold text-white hover:bg-fern-dark" data-id="element-235" data-mp="3aehhdqf8nwes">
            Review
          </Link>}
      </div>
    </li>;
}